import { ProductType } from '@/product/constants/productTypes';

export enum PreviewType {
  Collection = 'collection',
}

export type PreviewResponse = {
  type: PreviewType.Collection;
  id: string;
  preview: PreviewFragment[];
};

export interface PreviewFragment {
  url: Nullable<string>;
  bg?: Nullable<string>;
  isRender?: boolean;
  placeholder?: Nullable<PreviewFragmentPlaceholder>;
}

export interface PreviewFragmentPlaceholder {
  type: ProductType;
  cutShapeId?: Nullable<number>;
}
